<template>
  <div>
    <v-card class="mx-auto group-session" outlined>
      <h3 class="main-color text-center">
        {{ $t("Group") }} {{ session.subject }}
      </h3>
      <p class="third-color mb-0  text-center">
        {{ $t("Grade") }} {{ session.grade }}
      </p>
      <p class="third-color  mb-0  text-center">
        {{ $t("Language") }} {{ session.language }}
      </p>
      <v-card-text>
        <div>
          <p class="mb-0" v-if="session.lessons && session.lessons.length == 1">
            <strong class="main-color">{{ $t("Fees") }}: </strong
            >{{ session.lessons[0].lesson_fees }}
            {{ $t("currency") }}
          </p>
          <p class="mb-0" v-if="session.lessons && session.lessons.length == 1">
            <strong class="main-color">{{ $t("Date") }}: </strong
            >{{ session.lessons[0].date }}
          </p>
          <p class="mb-0" v-if="session.lessons && session.lessons.length == 1">
            <strong class="main-color">{{ $t("Time") }}: </strong>
            {{ session.lessons[0].start }} -
            {{ session.lessons[0].end }}
          </p>
          <div class="text-center">
            <slot></slot>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "teacherGroupCard",
  props: ["session"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scope>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";
/* group sessions */
.group-session {
  border: 1px solid $second-color !important;
  padding-top: 10px;
  height: 250px !important;
  border-radius: 10px;
}
</style>
